import React, { Component } from 'react'
import { translate } from 'react-i18next'
import Error from './Error'
import RecursiveElement from './RecursiveElement'
import Spinner from './Spinner'

class VCWPPosts extends Component {
  constructor(props) {
    super(props)
    this.state = {
      posts: null,
      target: 'VCWPPosts', // FIXME: from props?
      limit: this.props.number,
      nextPage: null,
      isFetching: null
    }

    if (props.pagination[this.state.target] === undefined)
      props.findPosts({ target: this.state.target, limit: this.state.limit })
  }

  handleNextPage = e => {
    e.preventDefault()
    this.props.findPosts({
      target: this.state.target,
      page: this.state.nextPage,
      limit: this.state.limit
    })
  }

  static getDerivedStateFromProps(props, state) {
    if (props.pagination[state.target] !== undefined) {
      return {
        posts: props.pagination[state.target].ids.map(id => props.entities[id]),
        nextPage: props.pagination[state.target].nextPage,
        isFetching: props.pagination[state.target].isFetching,
      }
    }

    return null
  }

  render() {
    if (this.props.pagination[this.state.target] !== undefined && this.props.pagination[this.state.target].code !== null && this.props.pagination[this.state.target].code !== 200)
      return <Error>{this.props.t('err.oops')}</Error>

    if (this.state.posts === null)
      return <Spinner>{this.props.t('msg.loadingMenu')}</Spinner>

    return (
      <div className={this.props.className}>
        {this.state.posts.map((post, key) => (
          <div>
            <span>Post: {post.getTitle()}</span>
            <RecursiveElement element={post.getDom()} />
          </div>
        ))}
        {this.state.nextPage ?
          <button onClick={this.handleNextPage}>{this.props.t('more')}</button>
        :
          null
        }
      </div>
    )
  }
}

export default translate()(VCWPPosts)



// WEBPACK FOOTER //
// ./src/components/VCWPPosts.js